<div class="tidy-textarea-field" (click)="textareaElement.focus()">
  @if (label) {
    <tidy-text
      [id]="labelId"
      [fieldLabel]="label"
      class="field-label"
      [class.error]="!form?.valid && submitted"></tidy-text>
  }

  <div
    class="textarea-container"
    [class.invalid-field]="!form?.valid && !loadingState.loading && submitted"
    [class.focused]="focused"
    [class.has-left-action]="leftIconAction"
    [class.has-right-action]="rightIconAction">

    @if (icon) {
      <tidy-image [src]="icon" class="input-icon no-right-margin"></tidy-image>
    }

    @if (leftIconAction) {
      <button
        class="action-button left-action"
        [disabled]="loadingState.loading"
        (click)="executeLeftIconAction()"
        [ngClass]="{ 'black-background': showBlackButtons }">
        <mat-icon>{{attachmentIcon ? attachmentIcon : 'camera_alt'}}</mat-icon>
      </button>
    }

    <textarea
      #textareaElement
      [id]="resolvedInputId"
      [attr.aria-labelledby]="label ? labelId : null"
      [attr.aria-label]="label ? null : (helperText || null)"
      cdkTextareaAutosize
      [(ngModel)]="value"
      (focus)="setFocused(true)"
      (keyup)="keyUpHandle($event)"
      (keydown)="onKeyDown($event)"
      (focusout)="setFocused(false)"
      [placeholder]="helperText || ''">
    </textarea>

    @if (rightIconAction) {
      <button
        class="action-button right-action"
        [ngClass]="{ 'empty': isInputEmpty, 'black-background': showBlackButtons }"
        [disabled]="loadingState.loading || isInputEmpty"
        (click)="executeRightIconAction()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    }
  </div>

  @if (!form?.valid && submitted) {
    <tidy-error-message [text]="errorMessage"></tidy-error-message>
  }
</div>
